import weekRange from './weekRange'

export default ({
  setHoverRange,
}) => (date) => (
  setHoverRange(weekRange(date))
)
